import i18next from 'i18next';

import ar from './navigation-i18n/ar';
import en from './navigation-i18n/en';
import tr from './navigation-i18n/tr';
import ptbr from './navigation-i18n/ptbr';

import authRoles from '../auth/authRoles';

i18next.addResourceBundle('en', 'navigation', en);
i18next.addResourceBundle('tr', 'navigation', tr);
i18next.addResourceBundle('ar', 'navigation', ar);
i18next.addResourceBundle('ptbr', 'navigation', ptbr);

const navigationConfig = [
  {
    id: 'dashboards',
    title: 'Dashboard',
    subtitle: 'Dashboard',
    type: 'group',
    icon: 'heroicons-outline:home',
    translate: 'DASHBOARDS',
    url: '/apps/dashboard'
  },
  {
    id: 'apps',
    title: 'Applications',
    subtitle: 'Custom made application designs',
    type: 'group',
    icon: 'heroicons-outline:home',
    translate: 'APPLICATIONS',
    children: [  
      {
        id: 'apps.planejamento',
        title: 'Planejamento',
        type: 'item',
        url: '/apps/planejamento',
        icon: 'heroicons-outline:support',
      },
      {
        id: 'apps.terms',
        title: 'Termos',
        type: 'item',
        url: '/apps/terms',
        icon: 'heroicons-outline:support',
      },
      {
        id: 'apps.profile',
        title: 'Meu Perfil',
        type: 'item',
        icon: 'heroicons-outline:user-circle',
        url: '/apps/profile',
      },
    ],
  },
];

export default navigationConfig;
